import * as styles from "./MainVisual.styles";

export default function MainVisual() {
  return (
    <>
      <div css={styles.mv}>
        <div css={styles.center}>
          <h1>Transition</h1>
          <p>Shimon Dotera's site ver.4</p>
        </div>
      </div>
    </>
  );
}
